import { Route, IndexRedirect } from 'react-router';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import { routes } from 'pluton-core/lib/constants/routes.constant';

/* entry */
import AuthComponent from './AuthComponent';

/* layout */
import App from '../../containers/layouts/App.jsx';
import MainLayout from '../../containers/layouts/Main.layout.jsx';

/* auth */
import LoginContainer from '../../containers/pages/auth/Login.container.jsx';
import PinContainer from '../../containers/pages/auth/Pin.container.jsx';
import RegisterContainer from '../../containers/pages/auth/Register.container.jsx';
import ResetPasswordContainer from '../../containers/pages/auth/ResetPassword.container.jsx';

/* core */
import HomeContainer from '../../containers/pages/core/Home.container.jsx';
import CostContainer from '../../containers/pages/core/Cost.container.jsx';
import ControlContainer from '../../containers/pages/core/Control.container.jsx';
import AlertContainer from '../../containers/pages/core/Alert.container.jsx';
import MoreContainer from '../../containers/pages/core/More.container.jsx';
import DeviceContainer from '../../containers/pages/core/Device.container.jsx';

/* service */
import NotFoundContainer from '../../components/pages/service/notFound/NotFound.page.jsx';
import SettingsContainer from '../../containers/pages/service/Settings.container.jsx';
import UtilitySettingsContainer from '../../containers/pages/service/UtilitySettings.container.jsx';

/* tmp */
import DemoContainer from '../../containers/pages/tmp/Demo.container.jsx';


const canEnterNotLoggedIn = false;

const Routes = ({ store, history }) => {
    return (
        <Provider store={store}>
            <Router history={history}>
                <Route path="/" component={App}>
                    <Route component={MainLayout}>
                        <IndexRedirect to={routes.home()}/>

                        /* auth */
                        <Route path={routes.pin()}
                               component={AuthComponent(PinContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.login()}
                               component={AuthComponent(LoginContainer)}/>
                        <Route path={routes.register()}
                               component={AuthComponent(RegisterContainer)}/>
                        <Route path={routes.restorePassword()}
                               component={AuthComponent(ResetPasswordContainer)}/>

                        /* core */
                        <Route path={routes.home()}
                               component={AuthComponent(HomeContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.cost()}
                               component={AuthComponent(CostContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.control()}
                               component={AuthComponent(ControlContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.deviceRaw()}
                               component={AuthComponent(DeviceContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.alert()}
                               component={AuthComponent(AlertContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.more()}
                               component={AuthComponent(MoreContainer, canEnterNotLoggedIn)}/>

                        /* tmp */
                        <Route path={routes.demo()}
                               component={AuthComponent(DemoContainer)}/>

                        /* service */
                        <Route path={routes.settingsNonAuth()}
                               component={AuthComponent(SettingsContainer)}/>
                        <Route path={routes.settings()}
                               component={AuthComponent(SettingsContainer, canEnterNotLoggedIn)}/>
                        <Route path={routes.utilitySettings()}
                               component={AuthComponent(UtilitySettingsContainer, canEnterNotLoggedIn)}/>
                        <Route path="404"
                               component={NotFoundContainer}/>
                        <Route path='*'
                               component={NotFoundContainer}/>
                    </Route>
                </Route>
            </Router>
        </Provider>
    );
};

export default Routes;



// WEBPACK FOOTER //
// ./app/entry/components/Routes.jsx